import React from "react";

const ShippingAndDelivery = () => {
  return (
    <div className="w-full">
      {/* Shipping Details */}
      <div className=" w-full ">
        <h2 className="text-2xl font-bold text-[#c61d21]">Shipping Policy</h2>
        <p className="text-start font-['Roboto'] text-black text-lg">
          Areas We Ship To
          <br />
          <br />
          ASIA, AFRICA, MIDDLE EAST*, AUSTRALIA, EUROPE, SOUTH AMERICA & NORTH
          AMERICA
          <br />
          <br />
          *Except following countries BAHRAIN, OMAN, QATAR, SAUDI ARABIA, SYRIA,
          UNITED ARAB EMIRATES and YEMEN.
        </p>
        <p className="text-start font-['Roboto'] text-black text-lg">
          *Air Mail Economy (India Post) service is available only for the
          selected 39 countries worldwide given below.
        </p>
        <p className="text-start font-['Roboto'] text-black text-lg">
          China, Japan, Malaysia, Russia, Singapore, Thailand, Uzbekistan,
          Botswana, Kenya, Mauritius, Morocco, Seychelles, South Africa,
          Zimbabwe, Austria, Denmark, Finland, France, Germany, Greece, Italy,
          Netherlands, Norway, Portugal, Spain, Sweden, Switzerland, United
          Kingdom, Brazil, Canada, Mexico and United States
        </p>
      </div>

      <h2 className="text-2xl font-bold text-[#c61d21]">
        Shipping & Handling Charges
      </h2>
      <div>
        <p className="text-start font-['Roboto'] text-black text-lg">
          To see the shipping price of your chosen book(s), simply select the
          country you wish to send the order to in the Estimate shipping /
          Postage calculator page in the shopping cart and it will give you the
          approximate Shipping Price! (Additional Handling / Administrative Fees
          are applicable)
          <br />
          <br />
          *Attention Depending on the destination country, customs duties,
          consumption tax and other additional costs may be levied. These are
          entirely the responsibility of the customer.
          <br />
          <br />
          *All prices shown on Estimate shipping / Postage calculator are in
          Indian Rupees (INR) / US Dollars (USD) /Euro (EUR)
          <br />
          <br />
          You can get an approximate price for shipping to a particular country
          using the postage calculator on the first step of checkout on the
          shopping cart page by selecting the destination country and state.
        </p>
      </div>
      <div>
        <h2 className="text-2xl font-bold text-[#c61d21]">Delivery</h2>
        <p className="text-start font-['Roboto'] text-black text-lg">
          We will ship your order within nine business days from the day after
          the payment for your order is confirmed. Orders are shipped by India
          Post /Express Mail Service (EMS) (with some exceptions). The order
          should arrive at its destination as per the transit time for the
          chosen mode of the shipment.
          <br />
          <br />
          Notification of book shipment on Book Order tracking page We will post
          “Shipping details” on the Book Order Tracking page once the shipment
          has been handed over to India Post/ EMS.
        </p>
        <h2 className="text-2xl font-bold text-[#c61d21]">
          Information Regarding Contacting Shipment Couriers India Post / EMS
        </h2>
        <p className="text-start font-['Roboto'] text-black text-lg">
          Example of the Contact (Tracking) Number: CP 123456789 IN /EE
          123456789 IN
          <br />
          <br />
          Enter your tracking number into the tracking services of your home
          country’s post office website (excluding some countries) to view the
          current status of your package.
        </p>

        <ol className="list-disc font-['Roboto'] ">
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            India Speed Post:{" "}
            <a href="http://services.ptcmysore.gov.in/Speednettracking/">
              http://services.ptcmysore.gov.in/Speednettracking/
            </a>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            EMS Tracking: (Japan Post) *{" "}
            <a href="http://www.post.japanpost.jp">
              http://www.post.japanpost.jp
            </a>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21] ">
            Singapore :{" "}
            <a href="http://www.speedpost.com/sg">
              http://www.speedpost.com/sg
            </a>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Canada:{" "}
            <a href="http://www.canadapost.ca">http://www.canadapost.ca</a>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            USA: <a href="http://www.usps.com">http://www.usps.com</a>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Australia:{" "}
            <a href="http://www.usps.com">http://ice.auspost.com.au</a>
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Korea: <a href="http://www.epost.go.kr">http://www.epost.go.kr</a>
          </li>
        </ol>
      </div>

      <div>
        <h2 className="text-2xl font-bold text-[#c61d21]">
          <h2 className="text-2xl font-bold text-[#c61d21]">Shipping Time</h2>
        </h2>
        <p className="text-start font-['Roboto'] text-black text-lg">
          We strive to ship all orders within nine days (counted from the day
          after the order was placed), but this may occasionally be exceeded due
          to a high number of orders.
          <br />
          <br />
          *Please note, if you have custom ordered book(s), your shipment date
          will be settled between you and a customer service representative.
          –Contact Us
        </p>
      </div>
      <div>
        <h2 className="text-2xl font-bold text-[#c61d21]">
          <h2 className="text-2xl font-bold text-[#c61d21]">
            Shipping And Handling Charges
          </h2>
        </h2>

        <p className="text-start font-['Roboto'] text-black text-lg">
          *Shipping and handling charges are set based on the total amount of
          ordered book(s) and those charges include the Express Mail Service
          (EMS) or international courier (TNT, FedEx and DHL) postage fees, etc.
          <br />
          <br />
          *In the event that a customer refuses to accept the delivery of an
          order, or if an order is returned to us after the retention period at
          the post office has passed after failed delivery attempts, we cannot
          provide any sort of refund.
        </p>

        <h2 className="text-2xl font-bold text-[#c61d21]">
          Returns And Exchanges
        </h2>
        <p className="text-start font-['Roboto'] text-black text-lg">
          *To be eligible to return and / or exchange book(s), customers must
          contact ISKCON vijayawada  Store with information regarding the
          book(s) you wish to return within fourteen days of receipt of shipment
          by e-mail. We will only accept returns of book(s) that we have
          confirmed for return. Please ship the confirmed return book(s) back to
          us within seven days.
          <br />
          <br />
          *We will not accept a request for a return and /or exchange if
          customers contact us after the fourteen-day period is over, or returns
          the books to us without prior notice.
        </p>
        <h2 className="text-2xl font-bold text-[#c61d21]">
          In case of “Circumstances arising with ISKCON vijayawada  Book Store”,
          we will accept the return / exchange from the customer if
        </h2>

        <ol className="list-disc font-['Roboto'] ">
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            (a) The book is different from what the customer ordered (wrong
            shipment).
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            (b) The book is defective.
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            (c) The book is damaged.
          </li>
        </ol>
        <p className="text-start font-['Roboto'] text-black text-lg">
          We will reimburse the customer for shipping costs incurred.
          <br />
          <br />
          In the event of a return of multi volume book set, please include all
          the books in the set in the condition that it was delivered, when
          making the return. If any of the books are missing from the set, we
          will not be able to process your return.
        </p>
        
      </div>
    </div>
  );
};

export default ShippingAndDelivery;
